export default __webpack_public_path__ + "static/media/sesonal.14527316.jpg";